import React from 'react'
import { useEffect } from 'react'
import { addgovtJobs } from '../../../actions/utilitiesAction'
import constant from '../../../constant'
// import { addGovtDepartment } from '../../../actions/utilitiesAction'
import AddGovtJob from '../../../component/Utilities/GovernmentJobs/AddGovtJobs'

const AddGovtJobs = () => {
    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)

    useEffect(() => {
        document.title = constant.title.AddGovtJobs
    })

    const onSubmit = (model) => {
        addgovtJobs(model).then((res) => {
            setResponse(res)
            setShowMsg(true)
            setTimeout(() => {
                setShowMsg(false)
            }, 2000)
        }).catch((err) => {
            alert(err)
        })
    }

    

    return (
        <React.Fragment>
            <AddGovtJob 
            onSubmit={onSubmit}
            response={response} showMsg={showMsg}
            />
        </React.Fragment>
    )
}
export default AddGovtJobs;